import { render, staticRenderFns } from "./Product2Manager.vue?vue&type=template&id=2d698c77&scoped=true"
import script from "./Product2Manager.vue?vue&type=script&lang=js"
export * from "./Product2Manager.vue?vue&type=script&lang=js"
import style0 from "./Product2Manager.vue?vue&type=style&index=0&id=2d698c77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d698c77",
  null
  
)

export default component.exports